import React from 'react';

const Legal = ({ type }) => {
    const isPrivacy = type === 'privacy';
    const title = isPrivacy ? 'Política de Privacidad' : 'Términos de Servicio';
    const lastUpdated = '1 de Diciembre, 2025';

    return (
        <div className="min-h-screen bg-white font-roboto text-slate-900 pb-20">
            <div className="bg-slate-50 py-20 px-6 border-b border-slate-200">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-4xl md:text-5xl font-black mb-4">{title}</h1>
                    <p className="text-slate-500">Última actualización: {lastUpdated}</p>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-6 py-12 prose prose-lg prose-slate">
                {isPrivacy ? (
                    <>
                        <h3>1. Recopilación de Información</h3>
                        <p>
                            Recopilamos información para proporcionar mejores servicios a todos nuestros usuarios. Esto incluye información básica como el idioma que hablas, hasta cosas más complejas como los reportes que generas.
                        </p>
                        <h3>2. Uso de la Información</h3>
                        <p>
                            Utilizamos la información que recopilamos de todos nuestros servicios para proveerlos, mantenerlos, protegerlos y mejorarlos, para desarrollar nuevos servicios y para proteger a Hue y a nuestros usuarios.
                        </p>
                        <h3>3. Transparencia y Opciones</h3>
                        <p>
                            La gente tiene diferentes preocupaciones sobre privacidad. Nuestro objetivo es ser claros acerca de la información que recopilamos, de modo que puedas tomar decisiones con sentido sobre cómo se utiliza.
                        </p>
                    </>
                ) : (
                    <>
                        <h3>1. Aceptación de los Términos</h3>
                        <p>
                            Al acceder y utilizar Hue, aceptas estar sujeto a estos Términos de Servicio. Si no estás de acuerdo con alguna parte de los términos, entonces no podrás acceder al servicio.
                        </p>
                        <h3>2. Uso del Servicio</h3>
                        <p>
                            Te comprometes a usar el servicio solo para fines legales y de una manera que no infrinja los derechos de, restrinja o inhiba el uso y disfrute del servicio por parte de cualquier otra persona.
                        </p>
                        <h3>3. Modificaciones</h3>
                        <p>
                            Hue se reserva el derecho, a su sola discreción, de modificar o reemplazar estos Términos en cualquier momento. Si una revisión es material, intentaremos proporcionar un aviso de al menos 30 días antes de que entren en vigor los nuevos términos.
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default Legal;
